<template>
  <v-footer padless class="mb-0" height="230">
    <v-card
      flat
      tile
      class="text-center footer-body"
      :class="{
        'footer-body-xs': $vuetify.breakpoint.xs,
        'footer-body-sm': $vuetify.breakpoint.sm,
      }"
    >
      <v-card-text class="white--text pb-0 pt-1 px-1">
        <v-row no-gutters class="main-footer-content" justify="space-between">
          <v-col cols="4" class="text-left">
            <p>
              <span v-if="whitelabel.contactAddress">{{
                whitelabel.contactAddress
              }}</span>
              <br />
              <span v-if="whitelabel.contactEmail"
                >Email: {{ whitelabel.contactEmail }}</span
              >
            </p>
          </v-col>
          <v-col cols="4" class="text-center">
            <img class="footer-icon" :src="footerLogoUrl" />
          </v-col>
          <v-col cols="4" class="text-right">
            <p v-if="hasSocialLinks">Find us on social media</p>
            <a
              v-if="whitelabel.facebookPageUrl"
              :href="whitelabel.facebookPageUrl"
              target="_blank"
            >
              <v-icon class="social-icons">{{ icons.mdiFacebook }}</v-icon>
            </a>
            <a
              v-if="whitelabel.linkedInPageUrl"
              :href="whitelabel.linkedInPageUrl"
              target="_blank"
            >
              <v-icon class="social-icons">{{ icons.mdiLinkedin }}</v-icon>
            </a>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <p class="footer-legal-text">
          {{ whitelabel.name }} &copy; {{ currentYear }}
        </p>
        <div class="d-flex align-center justify-center">
          <a
            class="footer-legal-text"
            :href="whitelabel.termsAndConditionsLocation"
            target="_blank"
            >Website Terms &amp; Conditions</a
          >
          <span class="footer-legal-text ml-1 mr-1">|</span>
          <a
            class="footer-legal-text"
            :href="whitelabel.privacyNoticeLocation"
            target="_blank"
            >Privacy Notice</a
          >
          <span class="footer-legal-text ml-1 mr-1">|</span>
          <a
            class="footer-legal-text"
            :href="whitelabel.cookiePolicyLocation"
            target="_blank"
            >Cookie Policy</a
          >
        </div>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  import { mdiFacebook, mdiLinkedin } from '@mdi/js';

  export default {
    name: 'DefaultFooter',
    data: () => ({
      icons: {
        mdiFacebook: mdiFacebook,
        mdiLinkedin: mdiLinkedin,
      },
    }),
    computed: {
      currentYear() {
        return new Date().getFullYear();
      },
      footerLogoUrl() {
        return require('@/assets/' + this.whitelabel.images.footerLogo);
      },
      hasSocialLinks() {
        return (
          this.whitelabel.linkedInPageUrl || this.whitelabel.facebookPageUrl
        );
      },
    },
  };
</script>

<style scoped lang="scss">
  .footer-body {
    width: 100%;
    height: 100%;
    min-height: 230px;
    color: var(--v-white-base);
    font-weight: 400;
    line-height: 1.5;

    hr {
      background-color: var(--v-white-base);
      margin: auto;
      width: 95%;
    }

    .main-footer-content {
      padding: 35px 48px 10px 48px;

      .social-icons {
        height: 30px;
        width: 30px;
        color: var(--v-white-base);
      }

      .footer-icon {
        margin-bottom: 20px;
        max-height: 60px;
      }
    }

    .footer-legal-text {
      font-size: 16px;
      font-weight: 400;
      color: #fff;
      text-decoration: none;
      margin-bottom: 0;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  .footer-body-xs {
    .main-footer-content {
      padding: 18px 0 0 0;

      p {
        font-size: 12px;
      }
    }
  }

  .footer-body-sm {
    .main-footer-content {
      padding: 35px 48px 10px 48px;

      p {
        font-size: 14px;
      }
    }
  }
</style>
